const filters = [
  {
    name: "milk",
    label: "Sans lait",
  },
  {
    name: "meat",
    label: "Sans viande",
  },
  {
    name: "egg",
    label: "Sans oeuf",
  },
  {
    name: "beef",
    label: "Sans boeuf",
  },
  {
    name: "gluten",
    label: "Sans gluten",
  },
  {
    name: "porc",
    label: "Sans porc",
  },
  {
    name: "nuts",
    label: "Sans fruits à coques",
  },
  {
    name: "fish",
    label: "Sans poisson",
  },
  {
    name: "seafood",
    label: "Sans fruits de mer",
  },
  {
    name: "shellfish",
    label: "Sans crustacés",
  },
  {
    name: "celery",
    label: "Sans céleri",
  },
  {
    name: "sesame",
    label: "Sans sésame",
  },
  {
    name: "mustard",
    label: "Sans moutarde",
  },
  {
    name: "peanuts",
    label: "Sans cacahuètes",
  },
  {
    name: "soy",
    label: "Sans soja",
  },
  {
    name: "mollusc",
    label: "Sans mollusque",
  },
  {
    name: "cilantro",
    label: "Sans coriandre",
  },
  {
    name: "sulfites",
    label: "Sans sulfites",
  },
  {
    name: "spicy_pepper",
    label: "Sans piment",
  },
];
filters.sort((a, b) => a.label.localeCompare(b.label));
export default filters;
